import type { OptionType } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';

export const useReminderDurationOptions = (): OptionType[] => {
  const { t } = useTranslation('guestSiteCustom');
  const durationOptions = t('reminderModal', 'durationOptions');

  return [
    {
      value: '1',
      label: durationOptions['1week'](),
    },
    {
      value: '2',
      label: durationOptions['2weeks'](),
    },
    {
      value: '3',
      label: durationOptions['3weeks'](),
    },
    {
      value: '4',
      label: durationOptions['4weeks'](),
    },
    {
      value: '5',
      label: durationOptions['5weeks'](),
    },
    {
      value: '6',
      label: durationOptions['6weeks'](),
    },
  ];
};

export const DEV_REMINDER_MINUTES_PER_WEEK = 5;
export const REMINDER_MODAL_TRIGGER_DELAY_MS = 15000;
export const MINIMUM_DAYS_BEFORE_EVENT_FOR_REMINDER = 13;
